const translations = {
  'fields.name': 'Nome',
  'fields.createdAt': 'Data de Criação',
  'fields.updatedAt': 'Última Atualização',
  'fields.branch': 'Filial',
  'fields.headquarter': 'Matriz',
  'fields.status': 'Status',
  'fields.checklist': 'Questionário',
  'fields.user': 'Usuário',
  'fields.scheduling': 'Data de Agendamento',
  'fields.endDate': 'Data de Conclusão',
  'fields.notes': 'Observações',
  'fields.checkIn': 'Check In',
  'fields.checkOut': 'Check Out',
  'fields.headquarterBranch': 'Cliente',
  'fields.assets': 'Ativos',
  'fields.activityScore': 'Pontuação de atividade',
  'fields.negatives': 'Respostas não',
  'fields.actionPlans': 'Planos de ação',
  'fields.serviceTime': 'Tempo de atendimento',
  'resume.filters.questionTypes': 'Tipo de pergunta',
  'resume.filters.answerTypes': 'Respostas',
  'resume.filters.actionPlans': 'Planos de Ação',
  'resume.accordion.general': 'Resumo Geral',
  'resume.accordion.negatives': 'Respostas Não',
  'resume.accordion.actionPlans': 'Planos de Ação',
  'resume.accordion.pendencies': 'Pendências',
  'execution.accordion.general': 'Detalhes',
  activities: 'Atividades',
  listing: 'Listagem',
  actionPlans: 'Planos de Ação',
  'resume.pdf.betaAlertTitle': 'Nova geração de PDF ainda está em desenvolvimento',
  'resume.pdf.betaAlertMessage': 'Iremos te redirecionar para a versão antiga para gerar sua impressão, pode ser?',
  'pdf.options.printSettingsTitle': 'Configurações da impressão',
  'pdf.options.showQuestionInfo': 'Mostrar informações das perguntas',
  'pdf.options.hideConfidentialInfo': 'Ocultar campos adicionais confidenciais',
  'pdf.options.hidePrivateQuestion': 'Ocultar perguntas confidenciais',
  'pdf.options.hideChildrenServiceOrders': 'Ocultar atividades filhas',
  'pdf.options.childrenFieldsTitle': 'Campos das atividades filhas',
  'pdf.options.showField': 'Mostrar {{field}}',
  'pdf.options.headerImageTitle': 'Imagem de cabeçalho',
  'pdf.options.headerImageHeight': 'Altura da imagem',
  'pdf.options.add': 'Adicionar',
  'pdf.counters.score': 'Pontuação',
  'pdf.counters.nonCompliances': 'Não conformidades',
  'pdf.counters.actionPlans': 'Planos de Ação',
  'pdf.counters.time': 'Tempo',
  'pdf.reason': 'Motivo',
  'pdf.createdAt': 'Criada em {{date}}',
  anonymousResponse: 'Respondido anonimamente',
  'show.userOrGroup': 'Usuário/Grupo',
  'show.placeOrPerson': 'Local/Pessoa',
  'show.asset': 'Ativo',
  'show.checklist': 'Questionário',
  'show.scheduling': 'Agendamento',
  'show.priority': 'Prioridade',
  'show.sla': 'SLA',
  'show.address': 'Endereço',
  'show.description': 'Descrição',
  'show.publicExecutionLink': 'Link público de execução',
  'show.publicResumeLink': 'Link público de resumo',
  'show.documents': 'Documentos',
  'show.history': 'Histórico',
  'show.noDate': 'Sem data',
  'show.noPriority': 'Sem prioridade',
  'show.openedAt': 'Data de abertura',
  'tabs.details': 'Detalhes',
  'tabs.timeline': 'Linha do tempo',
  'tabs.triggerEvents': 'Eventos de gatilho',
  'tabs.audit': 'Auditoria',
  'bulkEdit.title': 'Cadastro em massa',
  'clone.title': 'Clonando Atividade',
  'clone.message': 'Essa ação irá criar uma nova atividade com os mesmos dados da atividade {{yearlyId}}',
  'editStatus.title': 'Alterando status da atividade',
  'editStatus.title_plural': 'Alterando status das atividades',
  'export.title': 'Exportando atividade',
  'export.title_plural': 'Exportando atividades',
  'remove.button': 'Remover',
  'execution.title': 'Respondendo atividade: {{title}}',
  'resume.title': 'Resumo: {{yearlyId}}',
  'resume.fullResume': 'Resumo completo',
  'statusReason.unproductiveReason': 'Motivo do improdutividade',
  'statusReason.evidences': 'Evidências',
  'statusReason.signature': 'Assinatura',
  'statusReason.name': 'Nome',
  'statusReason.document': 'Documento',
  'indicators.nonCompliances': 'Não conformidades',
  'execution.saveError': 'Erro ao salvar as respostas',
  'execution.requiredAnswersMissing': 'Respostas obrigatórias faltando',
  'execution.requiredAnswersMissingMessage': 'Verifique as perguntas com as tags vermelhas.',
  'execution.sendError': 'Ocorreu um erro ao enviar as respostas',
  'execution.sendErrorMessage': 'Verifique as perguntas com as tags vermelhas.',
  'execution.paused': 'Atividade pausada',
  'execution.completed': 'Atividade concluída!',
  'execution.saved': 'Atividade salva!',
  'resume.generateCustomDocument': 'Gerar Documento Personalizado',
  'resume.generatePDF': 'Gerar PDF',
  'export.validation.missingIds': 'Faltando ids',
  'export.validation.required': 'Campo obrigatório',
  'export.sendingRequest': 'Enviando pedido...',
  'export.generatingFile': 'Gerando arquivo...',
  'export.error': 'Ocorreu um erro ao exportar!',
  'bulkEdit.openingAsChild': 'Abrindo como atividade filha de:',
  'bulkEdit.makeParentPending': 'Transformar pai em pendente',
  'bulkEdit.fields.code': 'Código',
  'bulkEdit.fields.name': 'Nome',
  'bulkEdit.fields.checklist': 'Questionário',
  'bulkEdit.fields.placeType': 'Tipo do destino',
  'bulkEdit.fields.place': 'Destino',
  'bulkEdit.fields.asset': 'Ativo',
  'bulkEdit.fields.responsible': 'Responsável',
  'bulkEdit.fields.address': 'Endereço',
  'bulkEdit.fields.scheduling': 'Agendamento',
  'bulkEdit.fields.priority': 'Prioridade',
  'bulkEdit.fields.description': 'Descrição',
  'interpolations.activityCode': 'Código da atividade',
  'interpolations.activityName': 'Nome da atividade',
  'interpolations.activityDescription': 'Descrição da atividade',
  'interpolations.checklistName': 'Nome do questionário',
  'interpolations.status': 'Status',
  'interpolations.projectName': 'Nome do projeto',
  'interpolations.placeName': 'Nome do local',
  'interpolations.publicResumeLink': 'Link público de resumo',
  'interpolations.publicExecutionLink': 'Link público de execução',
  'interpolations.userName': 'Nome do usuário',
  'interpolations.userEmail': 'Email do usuário',
  'interpolations.userGroup': 'Grupo do usuário',
  'interpolations.destinationName': 'Nome do destino',
  'interpolations.fullDestinationName': 'Nome completo do destino',
  'interpolations.schedulingDate': 'Data de agendamento',
  'interpolations.openingDate': 'Data de abertura (início ou criação)',
  'interpolations.completionDate': 'Data de conclusão',
  'interpolations.savedActivityUser': 'Usuário da atividade salva',
  'interpolations.updatedActivityPlace': 'Local da atividade atualizada',
  'interpolations.updatedActivityAsset': 'Ativo da atividade atualizada',
  'interpolations.savedActivityChecklist': 'Questionário da atividade salva',
  'interpolations.updatedNonCompliancePlace': 'Local da não conformidade atualizada',
  'interpolations.updatedNonComplianceAsset': 'Ativo da não conformidade atualizada',
  'interpolations.groups.activity': 'Atividade',
  'interpolations.groups.user': 'Usuário',
  'interpolations.groups.destination': 'Destino',
  'interpolations.groups.dates': 'Datas'
}

export default translations
